<a
    [attr.data-btnId]="getElementId('openMeasurements')"
    ngbTooltip="{{ tooltipContents }}"
    (click)="openDetails()">
    <fa-icon [icon]="['fas', icon]"></fa-icon>
</a>
